import { useEffect, useRef } from 'react';
import { useSearchBox } from 'react-instantsearch';

import AutoComplete from '../autoComplete/autoComplete';

import useModal from '@javascript/lib/hooks/useModal';
import Analytics from '@javascript/lib/analytics';

const HomeSearchBox = () => {
  const searchContainerRef = useRef<HTMLDivElement>(null);

  const { query, refine } = useSearchBox();

  const { ref, maskClickHandlers, closeModal, openModal } = useModal();

  useEffect(() => {
    if (query) {
      window.location.href = `/vehicles?query=${encodeURIComponent(query)}`;
    }
  }, [query]);

  const handleSuggestionSelect = (value: string | null) => {
    if (value) {
      // Analytics
      Analytics.trackEvent('click_cta', {
        label: `Instant search - homepage - ${value}`,
      });
      refine(value);
    } else {
      window.location.href = '/vehicles';
    }
  };

  return (
    <>
      <div className="search-container" ref={searchContainerRef}>
        <div className="ac-instant-search-homepage__search-box-wrapper">
          <input
            className="ac-instant-search-homepage__search-box ch-relative ch-flex--auto ch-form__control ch-fs--3 ch-fw--500 ch-color--grey-6 ch-pl--7"
            onFocus={(e) => {
              e.currentTarget.blur();
              openModal();
            }}
            readOnly
            type="text"
          />
          <span className="ac-autocomplete__placeholder" />
        </div>
      </div>
      <dialog {...maskClickHandlers} ref={ref}>
        <AutoComplete
          closeAutoComplete={closeModal}
          onSuggestionSelect={handleSuggestionSelect}
        />
      </dialog>
    </>
  );
};

export default HomeSearchBox;
